import React, { useEffect } from 'react';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { actionTypes } from 'src/ducks/flight-operator.duck';
import { getFlightOperatorStatus } from 'src/selectors/flight-operator.selector';
import FlightOperatorsView from './flight-operators-list.view';

const FlightOperators: React.FC = () => {
  const { state, actions } = useFlightOperatorContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <FlightOperatorsView
      loading={
        getFlightOperatorStatus(state, actionTypes.FLIGHT_OPERATOR_FETCH)
          .fetching
      }
      data={state.list}
    />
  );
};

export default FlightOperators;
